<template>
  <FinderCard
    data-test="finder-conditions-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex h-full flex-col justify-end gap-8">
      <li v-for="(value, index) in sortedValues" :key="value.name">
        <RevButtonBase
          :aria-pressed="isGradeSelected(index)"
          class="w-full text-left rounded-lg border-1 border-transparent px-16 py-14 motion-safe:transition motion-safe:duration-[225ms] outline-2 outline-offset-4 focus-visible:outline-default-hi"
          :class="
            isGradeSelected(index)
              ? 'bg-action-default-mid-pressed text-onaction-default-mid-pressed hover:bg-action-default-mid-hoverpressed'
              : 'bg-action-default-mid text-onaction-default-mid hover:bg-action-default-mid-hover'
          "
          :data-state="isGradeSelected(index) ? 'selected' : 'unselected'"
          :data-test="`finder-conditions-option-${gradeOf(value)}`"
          @click="toggleGrade(value)"
        >
          <span class="heading-3 block truncate">{{ value.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Facet } from '@backmarket/nuxt-layer-recommendation/filtering/types'
import { RevButtonBase } from '@ds/components/ButtonBase'

import type { FinderConditionsCriterion } from '../../../../composables/useFinder/useFinder.types'
import { useFinderTracking } from '../../../../composables/useFinder/useFinderTracking'
import FinderCard from '../FinderCard/FinderCard.vue'

const props = defineProps<{
  criterion: FinderConditionsCriterion
  facet?: Facet
}>()

const model = defineModel<string[]>({ default: () => [] })

function gradeOf(value: Facet['values'][number]): number {
  return Number.parseInt(value.name, 10) || 0
}

const sortedValues = computed(() =>
  [...(props.facet?.values ?? [])].sort((a, b) => gradeOf(b) - gradeOf(a)),
)

const { trackFinderOptionClick } = useFinderTracking()

const thresholdIndex = computed(() => {
  const index = sortedValues.value.findIndex((value) =>
    model.value.includes(value.name),
  )

  return index
})

function isGradeSelected(index: number): boolean {
  return thresholdIndex.value >= 0 && index >= thresholdIndex.value
}

function toggleGrade(value: Facet['values'][number]): void {
  trackFinderOptionClick(
    sortedValues.value.map((v) => ({ id: v.name, label: v.label })),
    value.name,
  )

  const index = sortedValues.value.findIndex((v) => v.name === value.name)

  if (index === thresholdIndex.value) {
    model.value = []
  } else {
    model.value = sortedValues.value.slice(index).map((v) => v.name)
  }
}
</script>
